import { message } from 'antd';
import axios from 'axios';

import { ROOT_URL } from '../../config';
import { ERROR, LOADING, SUCCESS } from '../../Constants/commonConstants';
import { getValidAccessToken } from '../../utils/authUtils';
import {
  ADD_REMOVE_BOOKMARK,
  DELETE_COMPARISON,
  DOCUMENT_COMPARE,
  DOCUMENT_COMPARE_RE_ANALYSIS,
  GET_SAVED_COMPARISON,
  RENAME_TITLE,
} from './compareTypes';

export const contextComparison = async (formData) => {
  return axios.post(`${ROOT_URL}/context_comparison/`, formData, {
    headers: {
      Authorization: `Bearer ${await getValidAccessToken()}`,
    },
  });
};

export function documentCompare({ documentsFormData, id, navigate }) {
  return async (dispatch) => {
    dispatch({
      type: DOCUMENT_COMPARE,
      compareStatus: LOADING,
    });
    try {
      let response = {};
      if (id) {
        response = await axios.get(`${ROOT_URL}/context_comparison/${id}`, {
          headers: {
            Authorization: `Bearer ${await getValidAccessToken()}`,
          },
        });

        dispatch({
          type: DOCUMENT_COMPARE,
          compareStatus: SUCCESS,
          // finalComparison: response.data.comparison.result.comparisons,
          // annotationData: response.data.comparison.result.annotations,
          // headingsData: response.data.comparison.result.headings,
          statusText: response.statusText,
          statusCode: response.status,
          // originalDocumentURL:
          //   response.data.comparison.converted_original_document_url,
          // modifiedDocumentURL:
          //   response.data.comparison.converted_modified_document_url,
          // sharedURL: response.data.comparison.shared_url,
          comparisonTitle: response.data.title,
          documentDetails: response.data.document_details.files_data,
          comparisonId: response.data.id,
          comparisonResults: response.data.result.comparison_result,
          contradictionResults: response.data.result.contradiction_results,
        });
      } else {
        response = await axios.post(`${ROOT_URL}/context_comparison/`, documentsFormData, {
          headers: {
            Authorization: `Bearer ${await getValidAccessToken()}`,
          },
        });

        dispatch({
          type: DOCUMENT_COMPARE,
          additionalAction: DELETE_COMPARISON,
          compareStatus: SUCCESS,
          // finalComparison: response.data.result.comparisons,
          // annotationData: response.data.result.annotations,
          // headingsData: response.data.result.headings,
          statusText: response.statusText,
          statusCode: response.status,
          // originalDocumentURL: response.data.converted_original_document_url,
          // modifiedDocumentURL: response.data.converted_modified_document_url,
          // sharedURL: response.data.shared_url,
          comparisonTitle: response.data.title,
          documentDetails: response.data.document_details.files_data,
          comparisonId: response.data.id,
          comparisonResults: response.data.result.comparison_result,
          contradictionResults: response.data.result.contradiction_results,
        });
      }
    } catch (e) {
      if (id) {
        navigate('/doccompare');
      } else {
        dispatch({
          type: DOCUMENT_COMPARE,
          compareStatus: ERROR,
          statusText: e.response.data.message,
        });
      }
    }
  };
}

export const reAnalysis = (id) => {
  return async (dispatch) => {
    dispatch({
      type: DOCUMENT_COMPARE_RE_ANALYSIS,
      compareStatus: LOADING,
    });
    try {
      //  https://mikecrapi-staging-v1.mikelegal.com/api/doc_compare/re_compare?doc_compare_id=459
      const response = await axios.get(`${ROOT_URL}/doc_compare/re_compare`, {
        headers: {
          Authorization: `Bearer ${await getValidAccessToken()}`,
        },
        params: {
          doc_compare_id: id,
        },
      });

      dispatch({
        type: DOCUMENT_COMPARE_RE_ANALYSIS,
        compareStatus: SUCCESS,
        finalComparison: response.data.result.comparisons,
        annotationData: response.data.result.annotations,
        headingsData: response.data.result.headings,
        statusText: response.statusText,
        statusCode: response.status,
        originalDocumentURL: response.data.converted_original_document_url,
        modifiedDocumentURL: response.data.converted_modified_document_url,
        sharedURL: response.data.shared_url,
        comparisonTitle: response.data.title,
        documentDetails: response.data.document_details,
        comparisonId: response.data.id,
      });
    } catch (e) {
      dispatch({
        type: DOCUMENT_COMPARE,
        compareStatus: ERROR,
        statusText: e.response.data.message,
      });
    }
  };
};

export const getSharedComparisonData = ({ id, navigate }) => {
  return async (dispatch) => {
    dispatch({
      type: DOCUMENT_COMPARE,
      compareStatus: LOADING,
    });

    try {
      const response = await axios.get(`${ROOT_URL}/doc_compare/comparison_share/`, {
        params: { shared_url_key: id },
      });

      dispatch({
        type: DOCUMENT_COMPARE,
        compareStatus: SUCCESS,
        finalComparison: response.data.comparison.result.comparisons,
        annotationData: response.data.comparison.result.annotations,
        headingsData: response.data.comparison.result.headings,
        statusText: response.statusText,
        statusCode: response.status,
        originalDocumentURL: response.data.comparison.converted_original_document_url,
        modifiedDocumentURL: response.data.comparison.converted_modified_document_url,
        sharedURL: response.data.comparison.shared_url,
        comparisonTitle: response.data.comparison.title,
        documentDetails: response.data.comparison.document_details,
        comparisonId: response.data.comparison.id,
      });
    } catch (e) {
      navigate('/');
    }
  };
};

export function getSavedComparisons() {
  return async (dispatch) => {
    dispatch({
      type: GET_SAVED_COMPARISON,
      getSavedCompareStatus: LOADING,
    });
    try {
      const response = await axios.get(`${ROOT_URL}/context_comparison`, {
        headers: {
          Authorization: `Bearer ${await getValidAccessToken()}`,
        },
      });
      dispatch({
        type: GET_SAVED_COMPARISON,
        getSavedCompareStatus: SUCCESS,
        savedComparisons: response.data.comparisons,
        totalComparisons: response.data.total_count,
        remainingQuota: response.data.remaining_quota,
      });
    } catch (e) {
      dispatch({
        type: GET_SAVED_COMPARISON,
        getSavedCompareStatus: ERROR,
        statusCode: e.response.status,
      });
    }
  };
}

export function deleteComparison(id) {
  return async (dispatch) => {
    dispatch({
      type: DELETE_COMPARISON,
      deleteComparisonStatus: LOADING,
    });
    try {
      await axios.delete(`${ROOT_URL}/context_comparison/${id}/`, {
        headers: {
          Authorization: `Bearer ${await getValidAccessToken()}`,
        },
      });
      dispatch({
        type: DELETE_COMPARISON,
        deleteComparisonStatus: SUCCESS,
      });
    } catch (e) {
      dispatch({
        type: GET_SAVED_COMPARISON,
        getSavedCompareStatus: ERROR,
      });
    }
  };
}

export function renameTitle(id, title) {
  return async (dispatch) => {
    dispatch({
      type: RENAME_TITLE,
      renameTitleStatus: LOADING,
    });
    try {
      await axios.patch(
        `${ROOT_URL}/context_comparison/${id}/`,
        {
          operation: 'rename_title',
          comparison_title: title,
        },

        {
          headers: {
            Authorization: `Bearer ${await getValidAccessToken()}`,
          },
        }
      );
      dispatch({
        type: RENAME_TITLE,
        renameTitleStatus: SUCCESS,
      });
    } catch (e) {
      message.error('Try after sometime.');
      throw new console.error(e);
    }
  };
}

export function addRemoveBookmark(comparisonId, id, flag) {
  return async (dispatch) => {
    dispatch({
      type: ADD_REMOVE_BOOKMARK,
      addRemoveBookmarkStatus: LOADING,
    });
    try {
      await axios.post(
        `${ROOT_URL}/context_comparison_action/`,
        {
          operation: 'SHORTLIST',
          value: flag,
          context_comparison_id: comparisonId,
          card_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${await getValidAccessToken()}`,
          },
        }
      );

      let response = {};
      try {
        response = await axios.get(`${ROOT_URL}/context_comparison/${comparisonId}`, {
          headers: {
            Authorization: `Bearer ${await getValidAccessToken()}`,
          },
        });
      } catch (e) {
        message.error('Something went wrong.');
      }

      dispatch({
        type: DOCUMENT_COMPARE,
        compareStatus: SUCCESS,
        statusText: response.statusText,
        statusCode: response.status,
        documentDetails: response.data.document_details.files_data,
        comparisonId: response.data.id,
        comparisonResults: response.data.result.comparison_result,
        contradictionResults: response.data.result.contradiction_results,
      });

      dispatch({
        type: ADD_REMOVE_BOOKMARK,
        addRemoveBookmarkStatus: SUCCESS,
      });
    } catch (e) {
      message.error('Try after sometime.');
      throw new console.error(e);
    }
  };
}

export function handleExport(id) {
  return async () => {
    try {
      const response = await axios.post(
        `${ROOT_URL}/context_comparison/export_data/`,
        {
          context_comparison_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${await getValidAccessToken()}`,
          },
        }
      );
      window.open(response?.data?.url, '_blank');
    } catch (e) {
      message.error('Try after sometime.');
      // throw new console.error(e);
    }
  };
}
